import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';

// custom (2026-08-22): o padrao do produto e o MODO CLARO, nao "seguir o sistema".
// O upstream cai em 'auto', o que faz a plataforma abrir ESCURA em toda maquina com o
// Windows/macOS no tema escuro — e as telas proprias (Inicio, CRM, Metricas) foram
// desenhadas e medidas em white mode. Quem quiser escuro escolhe pela paleta de comandos
// (useAppearanceHotKeys) e a escolha fica gravada no localStorage: este padrao so vale
// para quem nunca escolheu.
export const setColorTheme = isOSOnDarkMode => {
  const selectedColorScheme =
    LocalStorage.get(LOCAL_STORAGE_KEYS.COLOR_SCHEME) || 'light';
  const useDarkTheme =
    selectedColorScheme === 'dark' ||
    (selectedColorScheme === 'auto' && isOSOnDarkMode);

  document.body?.classList.toggle('dark', useDarkTheme);
  document.documentElement.classList.toggle('dark', useDarkTheme);
  document.documentElement.style.setProperty(
    'color-scheme',
    useDarkTheme ? 'dark' : 'light'
  );
};
